import mutations from './conflictingLabTests.mutations'
import actions from './conflictingLabTests.actions'
import getters from './conflictingLabTests.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
